import { useQuery } from '@tanstack/react-query';

import { fetchData } from 'src/app/queries';

export const GET_TEMPLATES = 'api/marketing-template/get-template-presets';

export type MarketingTemplatePreset = {
  DeletedAtUtc: string | null;
  HtmlBody: string;
  HtmlBodyS3FileName: string;
  Id?: string;
  IsDeleted: boolean;
  JsonBody: string;
  JsonBodyS3FileName: string;
  LastModifiedDateUtc: string | null;
  LspId: number;
  MarketingTemplatePresetId: number | null;
  TemplateName: string;
};

export type TemplatePageData = {
  Data: MarketingTemplatePreset[];
  Page: number;
  TotalPages: number;
  TotalRows: number;
};

export type Sort = {
  Direction: 'ASC' | 'DESC';
  Key: string;
};

export type Filter = {
  Key: string;
  Operator:
    | 'Contains'
    | 'Equal'
    | 'GreaterThan'
    | 'GreaterThanOrEqual'
    | 'LessThan'
    | 'LessThanOrEqual'
    | 'Like'
    | 'NotEqual'
    | 'NotNull';
  Value: string;
};

export type PagingRequest = {
  CurrentPage: number;
  Filters: Filter[];
  PageSize: number;
  Sorting: Sort[];
};

export const marketingTemplatePresetsQueryKey = ['marketing-template-presets'];

export function useGetTemplatesQuery(payload: PagingRequest) {
  return useQuery({
    queryKey: [...marketingTemplatePresetsQueryKey, payload],
    queryFn: () => fetchData<TemplatePageData>(GET_TEMPLATES, payload),
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false,
  });
}
